import {ProductInterface} from '../../../../../__generated__/__types__';

export const hasSpecialPrice = (product: ProductInterface) => {
    const {special_price, special_from_date, special_to_date} = product;
    if (special_price && special_from_date && special_to_date) {
        const now = new Date().getTime();
        const from = new Date(special_from_date).getTime();
        const to = new Date(special_to_date).getTime();
        return now >= from && now <= to;
    }
};

export const getSpecialPrice = (product: ProductInterface): number => {
    const {special_price} = product;
    if (hasSpecialPrice(product)) {
        return special_price ?? 0;
    }
    return 0;
};

export const getFinalPrice = (product: ProductInterface) => {
    const {price_range} = product;
    const {
        minimum_price: {final_price: minPrice},
        maximum_price: maximumPrice,
    } = price_range;
    const maxPrice = maximumPrice ? maximumPrice.final_price : minPrice;
    return maxPrice.value! > minPrice.value! ? maxPrice : minPrice;
};

export const getBasePrice = (product: ProductInterface) => {
    const {price_range} = product;
    const {
        minimum_price: {regular_price: minPrice},
        maximum_price: maximumPrice,
    } = price_range;
    const maxPrice = maximumPrice ? maximumPrice.regular_price : minPrice;
    return maxPrice.value! > minPrice.value! ? maxPrice : minPrice;
};

export const getMinimalPrice = (product: ProductInterface) => {
    const {price_range} = product;
    const {
        minimum_price: {final_price: minPrice},
        maximum_price: maximumPrice,
    } = price_range;
    const maxPrice = maximumPrice ? maximumPrice.final_price : minPrice;
    return maxPrice.value! > minPrice.value! ? minPrice : maxPrice;
};

export const getMaximumPrice = (product: ProductInterface) => {
    const {price_range} = product;
    const {
        minimum_price: {final_price: minPrice},
        maximum_price: maximumPrice,
    } = price_range;
    const maxPrice = maximumPrice ? maximumPrice.final_price : minPrice;
    return maxPrice.value! > minPrice.value! ? maxPrice : minPrice;
};

export const getSalesPercentage = (product: ProductInterface) => {
    const {price_range} = product;
    const {
        minimum_price: {final_price: minPrice},
        maximum_price: maximumPrice,
    } = price_range;
    const maxPrice = maximumPrice ? maximumPrice.final_price : minPrice;
    return maxPrice.value! > minPrice.value! ? ((maxPrice.value! - minPrice.value!) / maxPrice.value!) * 100 : 0;
};

//get higher discount percent from minimum or maximum price
export const getDiscountPercent = (product: ProductInterface): number => {
    const {price_range} = product;
    const {
        minimum_price: {discount: minDiscount},
        maximum_price: maximumPrice,
    } = price_range;
    const maxDiscount = maximumPrice ? maximumPrice.discount : minDiscount;

    return Math.max(minDiscount?.percent_off ?? 0, maxDiscount?.percent_off ?? 0);
};
